import { render, staticRenderFns } from "./rails_b_form.vue?vue&type=template&id=472e5f46&"
import script from "./rails_b_form.vue?vue&type=script&lang=js&"
export * from "./rails_b_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports